<template>
  <div class="root" style="height: 100%">
   
    <!-- Title Section -->
    <div style="display: flex; background-color: white; border-radius: 5px;" class="px-2 py-4">
      <div style="display:flex; flex:1;">
        <div style="display:flex; align-self: center;" class="px-2">
          <div style="display:flex; align-self: center;">
            <div class="headline">{{ !!mirrorZone['Description'] ? mirrorZone['Description']: mirrorZone['Name'] }}</div>
          </div>
          <div style="display:flex; align-content: left; align-items: center; align-self: center;margin-left: 15px">
            <v-chip label dark color="blue ml-2" v-if="getStageDisplayValue(apiParams['stage'])">{{ getStageDisplayValue(apiParams['stage'])}}</v-chip>
            <v-chip label dark color="blue ml-2" v-if="getColorFilterValue(apiParams['color'])"> {{ getColorFilterValue(apiParams['color']) }}</v-chip>
            <v-chip label outlined color="blue" class="mx-2">Expected : {{ data.expectedCartsCount }}</v-chip>
            <v-chip label outlined :color="availableCountColor" class="mx-2">Available : {{ data.availableCartsCount }}</v-chip>
            <v-chip label class="mx-2" v-if="nextLineMoveDate"> <b>Next Line Move Date :</b>  {{ nextLineMoveDate }}</v-chip>
          </div>     
          <v-progress-circular indeterminate color="primary" v-show="loading"></v-progress-circular>   
        </div>
        
      </div>
      
      <div style="display:flex; align-content: left; align-items: center; align-self: center;margin-left: 15px">
        <div class="blue-grey lighten-5 pa-2 d-sm-none d-lg-inline no-print">
          <span class="font-weight-bold body-2">LEGEND : </span>
          <span class="subtitle-2 pa-1 px-2 mx-1 rule-green" style="border: 1px solid transparent;font-weight: 400;">FULL</span>
          <span class="subtitle-2 pa-1 px-2 mx-1 rule-yellow" style="border: 1px solid transparent;font-weight: 400">PARTIAL</span>
          <span class="subtitle-2 pa-1 px-2 mx-1 rule-orange" style="border: 1px solid transparent;font-weight: 400">SURPLUS</span>
          <span class="subtitle-2 pa-1 px-2 mx-1 rule-white" style="border: 1px solid #AAAAAA;font-weight: 400">NOT IN MIRROR ZONE</span>
        </div>
        <div>
            <v-btn text color="primary" @click="toggleAppBarVisibility">
                  <v-icon large v-if="showFilters">fullscreen</v-icon>
                  <v-icon large v-if="!showFilters">fullscreen_exit</v-icon>
                  <!-- {{showFilters? 'options':'options'}} -->
              <!-- <v-icon>keyboard_arrow_up</v-icon> -->
            </v-btn>
          </div>
      </div>
      
    </div>

    <!-- Filter and Others Section -->
    <v-expand-transition>
      <div v-show="showFilters" style="display: flex; background-color: white; border-radius: 5px;" class="mt-2">
        <div  style="display: flex; align-self: center; padding:0 15px;">
          <ASearchForm
            :loading="loading"
            :modelName="'Cart'"
            :search="false"
            :dropdownProps="[
              {model:'mirrorzones', name: 'Mirror Zone', payloadKey: 'mirrorZoneId', notClearable: true},
              {type: 'dropdown', name: 'Stage' , payloadKey: 'stage', 'items': stageDropdownItems},
              {type: 'dropdown', name: 'Color' , payloadKey: 'color', 'items': colorDropdownItems}
            ]"
            :expandable="false"
            :hideSearchBtn="true"
            :hideFiltersInfo="true"
            :defaults="query"
            @change="onFilterChange"
            ref="ASearchForm"
            class="mb-4"
          ></ASearchForm>
          
          <div style="align-self: center;">
            <v-btn color="primary" text dark class="mb-2" @click="exportAsExcel">
            <v-icon left>get_app</v-icon>
            export
          </v-btn>
          </div>
      </div>
      </div>
    </v-expand-transition>

    
    <div class="board">
      <div v-for="station in data.stations" :key="station.id" class="station">
        <div>
          <div class="station-title">{{ station.name }}</div>
            <div class="lhg">
                <div class="lhg-item" v-for="lhg in station.lhgs" :key="lhg.id" :class="'rule-'+lhg.color.toLowerCase()">
                  <div style="display: flex;">
                    <div v-if="lhg.color.toLowerCase() == 'white-green-check'" style="align-self: flex-start;">
                      <v-icon small color="green">check_circle</v-icon>                   
                    </div>
                    <div style="flex: 1">
                      <div class="lhg-item-title">{{ lhg.name }}</div>              
                      <div class="cart-group-id">{{ (lhg.car.length > 1 ? (lhg.car + "-"): "") + lhg.cartGroupName }}</div>    
                    </div>
                  </div>
                </div>
          </div>    
        </div>
      </div>
    </div>
    <ATicker
      class="d-none"
      interval="5"
      :checked="true"
      label="Auto Refresh"
      showIntervalTime="true"
      @tick="onTick"
    ></ATicker>
  </div>
</template>

<script>
import ATicker from "../components/ATicker";
import ASearchForm from "../components/ASearchForm.vue";
import config from '../../config'
import axios from "../api/axios";
import {time} from "../utils"

let spliceKeyValue = {
  "presplice": "PRE SPLICE",
  "postsplice": "POST SPLICE"
};

export default {
  components: {
    ATicker,
    ASearchForm
  },
  props: [
    "showAppBar"
  ],
  data() {
    return {
      loading : false,
      apiParams: {},
      data: {},
      mirrorZone: {},
      lineMoveDateDetails: {},
      query: {},
      showFilters: false,
      stageDropdownItems: [{text: 'PRE SPLICE', value: 'presplice'}, {text: 'POST SPLICE', value: 'postsplice'}],
      colorDropdownItems: [
        {text: 'Green - Full', value: 'green'},
        {text: 'Yellow - Partial', value: 'yellow'},
        {text: 'Orange - Surplus', value: 'orange'},
        {text: 'White - Not in Mirror Zone', value: 'white'}
      ]
    };
  },
  computed: {
    availableCountColor() {
      if (this.data.expectedCartsCount == this.data.availableCartsCount)
        return "green"
      else
        return "red"
    },
    nextLineMoveDate() {
      if (this.lineMoveDateDetails.Next) 
        return time.toDateFormat3(this.lineMoveDateDetails.Next.StartDate)
    }
  },
  methods: {
    load: function() {
      this.loading = true;
      axios.get("/mirror-zone-view", { params: this.apiParams }).then(r => {
        this.loading = false;
        if (r.data.ok) {
          this.data = r.data.d;
          this.$router.replace({query: this.apiParams });
        }
      });
      axios.get(`/mirrorzones/${this.apiParams['mirrorZoneId']}`).then(r => {
        if (r.data.ok) {
          this.mirrorZone = r.data.d;
          axios.get(`/line-move-date-details`,{ params: {ContractId : this.mirrorZone.Contract.ID} } ).then(r => {
            if (r.data.ok) {
              this.lineMoveDateDetails = r.data.d;
            }
          })
        }
      });
      
    },
    queryParamValue(param) {
      return this.$route.query[param];
    },
    onTick: function() {
      this.load()
    },
    onFilterChange: function(payload) {
      this.apiParams = payload;
      this.load()
    },
    exportAsExcel: function() {
      window.open(config.axiosConfig.baseURL + "/mirror-zone-view" + "?export=true&" + (new window.URLSearchParams(this.apiParams)).toString(), "_blank")
    },
    getStageDisplayValue(key) {
      if (!key) return null
      return this.stageDropdownItems.filter(i => {
        console.log(`${i.value} == ${key}`)
        return i.value == key
      })[0].text.toUpperCase()
    },
    getColorFilterValue(key) {
      if (!key) return null
      return this.colorDropdownItems.filter(i => {
        console.log(`${i.value} == ${key}`)
        return i.value == key
      })[0].text.toUpperCase()
    },
    toggleAppBarVisibility() {
      this.$emit('update:showAppBar', !this.showAppBar)
      this.showFilters = !this.showFilters
    }
  },
  mounted() {
    this.$emit('update:showAppBar', false)
    this.query = this.$route.query;
  }
};
</script>

<style scoped>

@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }
}
.root {
  display: flex;
  flex-direction: column;
}

.board {
  background-color: #FFFFFF;
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, auto));
  grid-template-rows: repeat(auto-fill, auto);
  grid-auto-flow: row;
  padding: 1vh;
  width: 100%;
  height:100%;
  border-radius: 5px;
}

.station {
  margin: 1vh; 
  padding: 0.5vh;
  min-width: 300px;
  min-height: 100px;
  background-color: #f6f6f6;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  letter-spacing: 1px;
  break-inside: avoid;
}

.station-title {
  font-size: large;
  font-weight: bold;
  letter-spacing: 2px;
  color: rgb(159, 31, 31);
}

.lhg {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 120px));
  column-gap: 10px;
  row-gap: 5px;
  padding: 5px;
}

.lhg-item {
  margin: 2px;
  padding: 5px;
}

/* .lhg-item:hover {
  cursor: pointer;
  background-color: rgb(236, 218, 218) !important;
  border: 2px dashed rgb(188, 134, 134);
  transition: all 0.25s ease-in-out;
} */

.lhg-item.rule-green, .rule-green {
  background-color: rgb(125, 206, 160)
}

.lhg-item.rule-white, .rule-white {
  color: rgb(95, 91, 91);
  background-color: #ffffff
}

.lhg-item.rule-white-green-check, .rule-white-green-check {
  color: rgb(95, 91, 91);
  background-color: #ffffff
}

.lhg-item.rule-orange, .rule-orange {
  background-color:rgb(255, 165, 0)
}

.lhg-item.rule-yellow, .rule-yellow {
  background-color:rgb(249, 231, 159)
}

.lhg-item-title {
  font-size: small;
  font-weight: 500;
}

.cart-group-id {
  font-size: x-small;
}
</style>

